<section class="content-dialog">
    <div class="content-text">
        <h3 class="question">¿Quieres una renta mensual baja?</h3>
        <p>Leasing es la opción, al final del plazo puedes comprar el auto a valor del mercado, cambiarlo o devolverlo.</p>
        <div class="content-button">
            <button class="btn btn-action" [mat-dialog-close]="false" mat-button id="boton-cotizar-leasing-renting{{templateSuffix !== '' ? '-b' : ''}}">Cotizar Leasing</button>
        </div>
    </div>
    <div class="content-text">
        <h3 class="question">
            {{ "CREDIT.afin.rent2buy.title" | translate }}
        </h3>
        <p>
            {{ "CREDIT.afin.rent2buy.text" | translate }}
        </p>
        <div class="content-button">
            <button class="btn btn-action" [mat-dialog-close]="true" mat-button id="boton-cotizar-rent2buy{{templateSuffix !== '' ? '-b' : ''}}">
                {{ "CREDIT.afin.rent2buy.button" | translate }}
            </button>
        </div>
    </div>
</section>
  
